export default "__VITE_ASSET___kSXGX7T__"